import React, { type FC } from "react";
import clsx from "clsx";
import ExteriorSlider from "../exterior-slider/ExteriorSlider";
import Upholstery from "../Upholstery";
import SpinNavigation from "../SpinNavigation";
import baseSectionStyles from "../../section-wrapper/SectionWrapper.module.scss";
import styles from "./SliderWrapper.module.scss";
import { useCarConfigSelector } from "../../../../../redux/store";

type sliderProps = {
    sticky?: boolean;
    sliderFrames?: number[];
    iswheel?: boolean;
};

const SliderWrapper: FC<sliderProps> = (props) => {
    const { sticky, sliderFrames = [3, 13, 0, 18], iswheel } = props;
    const sliderIsInitialized = useCarConfigSelector((state) => state.car.initialized);

    if (!sliderIsInitialized) {
        return null;
    }

    return (
        <figure className={clsx(baseSectionStyles["exterior-slider"], sticky && styles.slider)}>
            <div className={styles["spin-container-visual"]}>
                <ExteriorSlider
                    frames={sliderFrames}
                    imageOptions={{ bgColour: "FFFFFF", width: 1600, height: 900, padding: 12 }}
                    isWheel={iswheel}
                />
                <div className={styles["spin-container-items"]}>
                    <Upholstery />
                </div>

                <div className={styles["spin-navigation-wrapper"]}>
                    <SpinNavigation />
                </div>
            </div>
        </figure>
    );
};

export default SliderWrapper;
